import { useEnterSearchAndFilterMode } from '../hooks/useEnterSearchAndFilterMode';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getClickedSearch } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import FormattedMessage from 'I18n/components/FormattedMessage';
import NewFeatureTourStep from '../../new-feature-onboarding/components/NewFeatureTourStep';
import { SEARCH_AND_FILTER_MODE_BUTTON } from '../../new-feature-onboarding/constants/OnboardingConstants';
import SearchAndFilterModeIcon from './SearchAndFilterModeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchAndFilterModeButton = () => {
  const {
    onEnterSearchAndFilterMode
  } = useEnterSearchAndFilterMode();
  const handleEnterSearchAndFilterMode = () => {
    onEnterSearchAndFilterMode();
    trackEvent(getClickedSearch());
  };
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2786) FIXME: 'NewFeatureTourStep' cannot be used as a JSX compo... Remove this comment to see the full error message
    _jsx(NewFeatureTourStep, {
      stepKey: SEARCH_AND_FILTER_MODE_BUTTON,
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.new-feature-onboarding.thread-search-and-filtering.search-and-filter-mode-button.header"
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.new-feature-onboarding.thread-search-and-filtering.search-and-filter-mode-button.body"
      }),
      placement: "bottom right",
      children: /*#__PURE__*/_jsx(SearchAndFilterModeIcon, {
        clickHandler: handleEnterSearchAndFilterMode
      })
    })
  );
};
SearchAndFilterModeButton.displayName = 'SearchAndFilterModeButton';
export default SearchAndFilterModeButton;